import React, { useEffect, useState } from "react";
import { Button, Typography, Box } from "@mui/material";
import IUser from "../../types/user-type";
import userService from "../../services/user-service";
import { FormattedMessage } from "react-intl";

interface RevealContactInfoProps {
  creatorId: string;
}

const RevealContactInfo: React.FC<RevealContactInfoProps> = ({ creatorId }) => {
  const [showContactInfo, setShowContactInfo] = useState(false);
  const [ownerInfo, setOwnerInfo] = useState<IUser>();

  const fetchOwnerInfo = async (creatorId: string) => {
    try {
      const response = await userService.getUserInfoById(creatorId);
      setOwnerInfo(response.data);
    } catch (error) {
      console.error("Failed to fetch owner info", error);
    }
  };

  useEffect(() => {
    if (creatorId) fetchOwnerInfo(creatorId);
  }, [creatorId]);

  const handleToggle = () => {
    if (!ownerInfo) fetchOwnerInfo(creatorId);
    setShowContactInfo((prev) => !prev);
  };

  return (
    <Box>
      <Button variant="contained" onClick={handleToggle}>
        {showContactInfo ? <FormattedMessage id="hide-info" /> : <FormattedMessage id="reveal-info" />}
      </Button>

      {showContactInfo && (
        <Box mt={2}>
          <Typography variant="body2">
            <strong>
              <FormattedMessage id="email" />: 
            </strong>{" "}
            {ownerInfo?.email}
          </Typography>
          <Typography variant="body2">
          <strong>
              <FormattedMessage id="phone" />: 
            </strong>{" "}
            {ownerInfo?.phonenumber}
          </Typography>
        </Box>
      )}
    </Box>
  );
};

export default RevealContactInfo;
